export default {
  MAX_BUSINESS_DESCRIPTION_CHARS: 1000,
  MAX_INPUT_CHARS: 100,
  MAX_SITE_NAME_CHARS: 56,
  MIN_SITE_NAME_CHARS: 3,
  TEMPLATES_PAGE_SIZE: 48,
};
